import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-074f41ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { class: "button-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 공유하기 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 문의하기 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 세무법인 혜움 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 환급금 무료 조회 ")

import HeumOverTaxLogo from '@/styles/icon/HeumOverTaxLogo.vue'
import { COLOR_SET } from '@/styles/variables'
import Text from '@/components/common/TextComponent.vue'
import RightAngleBracket from '@/styles/icon/RightAngleBracket.vue'
import { showChannelTalk } from '@/utils/channelTalk'
import { shareByKakao } from '@/utils/kakao'
import toRefund from '@/utils/toRefund'


export default /*#__PURE__*/_defineComponent({
  name: 'LandingHeader',
  setup(__props) {

const handleHeumTax = () => {
  location.href = 'https://www.heumtax.com/'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(HeumOverTaxLogo, { small: true }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "talk-button share button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(shareByKakao)('https://www.overtax.co.kr')))
        }, [
          _createVNode(Text, {
            size: "14px",
            color: _unref(COLOR_SET).blue01
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _createElementVNode("div", {
          class: "talk-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(showChannelTalk) && _unref(showChannelTalk)(...args)))
        }, [
          _createVNode(Text, {
            size: "14px",
            color: _unref(COLOR_SET).blue01
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _createElementVNode("div", {
          class: "home-button",
          onClick: handleHeumTax
        }, [
          _createVNode(Text, { size: "14px" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(RightAngleBracket, {
            color: _unref(COLOR_SET).gray01
          }, null, 8, ["color"])
        ]),
        _createElementVNode("div", {
          class: "refund-button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(toRefund) && _unref(toRefund)(...args)))
        }, [
          _createVNode(Text, {
            size: "14px",
            color: _unref(COLOR_SET).white
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["color"])
        ])
      ])
    ])
  ]))
}
}

})